import Image from '@/domain/model/image/Image.js';

/**
 * Image uploads. The server (ServiceCheckIn ImageExportToFileRequestHandler) writes the
 * base64 data to the CDN, saves the Image with a url and returns it. Upload images this
 * way before referencing them from another record: the inspection save does not export
 * images it is handed, so a comment saved with raw image data ends up with blank pictures.
 */
export default class ImageEvents {

  constructor(eventsDomain) {
    this.eventsDomain = eventsDomain;
    this.domain = this.eventsDomain.domain;
  }

  save(image) {
    var data = image.data ? image.data : image;
    var event = ImageEvents.Save.Request(data);
    return this.eventsDomain.initRequest(event);
  }

  static Save = {
    Names: {
      Request: 'ImageExportToFileRequestEvent',
      Response: 'ImageExportToFileResponseEvent',
    },

    Request: function (data) {
      var event = {
        handler: ImageEvents.Save.Names.Request,
        eventName: ImageEvents.Save.Names.Request,
      }
      event[Image.MODEL_NAME] = data;
      return event;
    },
  }
}
